"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var ResultSwitchIcon = function ResultSwitchIcon() {
  return _react["default"].createElement("svg", {
    width: "24px",
    height: "68px",
    viewBox: "0 0 24 68",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Inverse button",
    role: "img"
  }, _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(-659.000000, -798.000000)",
    fill: "#FFFFFF"
  }, _react["default"].createElement("g", {
    transform: "translate(190.000000, 774.000000)"
  }, _react["default"].createElement("g", {
    transform: "translate(469.000000, 24.000000)"
  }, _react["default"].createElement("path", {
    d: "M24,59.3617685 L13.7142857,68 L13.7142857,61.0887485 L10.6662857,61.0887485 C4.8,61.0887485 0,56.4242368 0,50.7235371 L0,38 L3.55542857,38 L3.55542857,50.7235371 C3.55542857,54.5339989 6.74514286,57.633678 10.6662857,57.633678 L13.7142857,57.633678 L13.7142857,50.7235371 L24,59.3617685 Z",
    transform: "translate(12.000000, 53.000000) scale(-1, 1) translate(-12.000000, -53.000000) "
  }), _react["default"].createElement("path", {
    d: "M24,8.63855126 L13.7142857,0 L13.7142857,6.91039675 L10.6662857,6.91039675 C4.8,6.91039675 0,11.5761918 0,17.2771025 L0,30 L3.55542857,30 L3.55542857,17.2771025 C3.55542857,13.4664996 6.74514286,10.3667058 10.6662857,10.3667058 L13.7142857,10.3667058 L13.7142857,17.2771025 L24,8.63855126 Z",
    transform: "translate(12.000000, 15.000000) scale(-1, 1) translate(-12.000000, -15.000000) "
  }))))));
};

var _default = ResultSwitchIcon;
exports["default"] = _default;